export default "__VITE_PUBLIC_ASSET__a2031c03__"